import React from 'react';
import { FadeIn } from './FadeIn';
import { Check } from 'lucide-react';
export function PricingCards() {
  return <section className="py-3 px-3 max-w-2xl mx-auto pt-[0px] pb-[0px] space-y-[0px] mt-[20px] mb-[20px]" id="pricing" data-id="element-225">
      <FadeIn data-id="element-226">
        <h2 className="text-lg md:text-xl font-black text-center mb-3" data-id="element-227">
          ELEGÍ TU MEGAPACK
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-xl mx-auto" data-id="element-228">
        {/* Card 1 */}
        <FadeIn delay={0.1} data-id="element-229">
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-3 h-full flex flex-col relative" data-id="element-230">
            <div className="mb-2" data-id="element-231">
              <h3 className="text-sm font-bold text-white flex items-center gap-1.5 mb-0.5" data-id="element-232">
                <span data-id="element-233">📘</span> MEGAPACK PROMPTS RENTABLES LISTO
              </h3>
              <p className="text-gray-400 font-medium text-xs" data-id="element-234">
                6 Tomos + 6 Bonos
              </p>
            </div>

            <div className="mb-2" data-id="element-235">
              <div className="text-red-400 line-through text-sm font-medium" data-id="element-236">
                $97.000
              </div>
              <div className="text-xl font-black text-white flex items-baseline gap-1" data-id="element-237">
                $19.990{' '}
                <span className="text-xs text-gray-400 font-medium" data-id="element-238">ARS</span>
              </div>
            </div>

            <ul className="space-y-1.5 mb-3 flex-grow" data-id="element-239">
              <li className="flex items-start gap-1.5" data-id="element-240">
                <Check className="text-green-500 shrink-0 mt-0.5" size={12} data-id="element-241" />
                <span className="text-gray-300 text-xs" data-id="element-242">
                  Ideal para: Freelancers, Media Buyers y Emprendedores que
                  quieren lanzar campañas rentables con IA
                </span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-243">
                <Check className="text-green-500 shrink-0 mt-0.5" size={12} data-id="element-244" />
                <span className="text-gray-300 text-xs" data-id="element-245">
                  Acceso a los 6 Tomos completos
                </span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-246">
                <Check className="text-green-500 shrink-0 mt-0.5" size={12} data-id="element-247" />
                <span className="text-gray-300 text-xs" data-id="element-248">
                  Los 6 Bonos de regalo
                </span>
              </li>
            </ul>

            <a href="https://tumanualdigital.com/cart/44132276240420:1" className="w-full block text-center py-1.5 px-3 rounded-md font-bold text-sm bg-gray-800 hover:bg-gray-700 text-white transition-colors border border-gray-700" data-id="element-249">
              → QUIERO MI MEGAPACK
            </a>
          </div>
        </FadeIn>

        {/* Card 2 - Featured */}
        <FadeIn delay={0.2} data-id="element-250">
          <div className="bg-gradient-to-b from-gray-900 to-black border-2 border-green-500 rounded-xl p-3 h-full flex flex-col relative transform md:-translate-y-1 shadow-[0_0_15px_rgba(34,197,94,0.15)]" data-id="element-251">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-green-500 text-black font-bold px-2.5 py-0.5 rounded-full text-[10px] flex items-center gap-1 whitespace-nowrap" data-id="element-252">
              ⭐ MÁS ELEGIDO
            </div>

            <div className="mb-2 mt-1.5" data-id="element-253">
              <h3 className="text-sm font-bold text-white flex items-center gap-1.5 mb-0.5" data-id="element-254">
                <span data-id="element-255">🏆</span> MEGAPACK + MÁSTER ESTRATEGA LISTO
              </h3>
              <p className="text-green-400 font-medium text-xs" data-id="element-256">
                6 Tomos + 6 Bonos + Sistema Avanzado de Funnels, Escalado y
                Agencia
              </p>
            </div>

            <div className="mb-2" data-id="element-257">
              <div className="text-red-400 line-through text-sm font-medium" data-id="element-258">
                $140.000
              </div>
              <div className="text-xl font-black text-white flex items-baseline gap-1" data-id="element-259">
                $27.990{' '}
                <span className="text-xs text-gray-400 font-medium" data-id="element-260">ARS</span>
              </div>
            </div>

            <ul className="space-y-1.5 mb-3 flex-grow" data-id="element-261">
              <li className="flex items-start gap-1.5" data-id="element-262">
                <Check className="text-green-500 shrink-0 mt-0.5" size={12} data-id="element-263" />
                <span className="text-gray-300 text-xs" data-id="element-264">
                  Ideal para: Media Buyers que quieren pasar del Nivel 2 al
                  Nivel 3 y cobrar 3 veces más
                </span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-265">
                <Check className="text-green-500 shrink-0 mt-0.5" size={12} data-id="element-266" />
                <span className="text-gray-200 font-medium text-xs" data-id="element-267">
                  Todo lo del Megapack Básico
                </span>
              </li>
              <li className="flex items-start gap-1.5 bg-green-900/20 p-1 rounded-md -mx-1" data-id="element-268">
                <Check className="text-green-400 shrink-0 mt-0.5" size={12} data-id="element-269" />
                <span className="text-green-100 font-bold text-xs" data-id="element-270">
                  Sistema Máster Estratega Completo
                </span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-271">
                <Check className="text-green-500 shrink-0 mt-0.5" size={12} data-id="element-272" />
                <span className="text-gray-300 text-xs" data-id="element-273">
                  4 Assets listos (Auditoría, Propuesta, etc)
                </span>
              </li>
            </ul>

            <a href="https://tumanualdigital.com/cart/44132277616676:1" className="w-full block text-center py-1.5 px-3 rounded-md font-bold text-sm bg-green-500 hover:bg-green-400 text-black transition-all hover:scale-[1.02] shadow-lg" data-id="element-274">
              → QUIERO EL MEGAPACK + MÁSTER ESTRATEGA
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}